import { render } from "./SiteFontSelect.vue?vue&type=template&id=aff98df6"
import script from "./SiteFontSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteFontSelect.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Sites/SiteFontSelect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "aff98df6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('aff98df6', __exports__)) {
    api.reload('aff98df6', __exports__)
  }
  
  module.hot.accept("./SiteFontSelect.vue?vue&type=template&id=aff98df6", () => {
    api.rerender('aff98df6', render)
  })

}


export default __exports__